import { useDropzone } from 'react-dropzone';
import i18n from 'i18next';

function useSingleFileDropzoneProps({
    enableBase64,
    config = {},
    onDropSuccess = () => {},
    onDropError = () => {}
} = {}) {
    async function onDropAccepted(acceptedFiles) {
        const file = acceptedFiles[0];
        let resp = { file };
        if (enableBase64) {
            resp.base64 = await getBase64(file);
        }
        onDropSuccess(resp);
    }
    async function onDropRejected(acceptedFiles) {
        const file = acceptedFiles[0];
        const { size, type } = file;
        if (size > dropzoneConfig.maxSize) {
            onDropError(
                i18n.t('notify.file_drop.failed.size', {
                    size: dropzoneConfig.maxSize / 1000 / 1000
                })
            );
        } else if (dropzoneConfig.accept.indexOf(String(type).toLowerCase()) === -1) {
            onDropError(
                i18n.t('notify.file_drop.failed.type', {
                    types: dropzoneConfig.accept
                        .split(',')
                        .map(e => e.split('/')[1])
                        .join(', ')
                        .toUpperCase()
                })
            );
        }
    }

    const dropzoneConfig = {
        ...generalConfig,
        ...config
    };
    const { getRootProps, getInputProps, open, inputRef } = useDropzone({
        onDropAccepted,
        onDropRejected,
        ...dropzoneConfig
    });

    return { getRootProps, getInputProps, open, inputRef };
}

export default useSingleFileDropzoneProps;

const generalConfig = {
    multiple: false,
    maxSize: 3000000,
    accept: 'image/png,image/gif,image/jpg,image/jpeg'
};

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
